/**
 * Custom Scoring Adapter
 *
 * Transforms scoring question data into CustomScoringQuestion component props.
 * Custom questions only support manual scoring (no feed stats, no auto-grading).
 */

import type { ScoringQuestionData } from '../types';

/**
 * CustomScoringQuestion component props
 */
export interface CustomScoringQuestionProps {
  questionText: string;
  questionSubtext?: string;
  questionNumber?: number;
  options: Array<{
    option_id?: string;
    option_text_en: string;
    option_text_fr?: string;
    option_image_en?: string | null;
    option_image_fr?: string | null;
    third_image_en?: string | null;
    third_image_fr?: string | null;
    is_correct: boolean;
  }>;
  points: number;
  status?: 'LIVE' | 'FINAL' | 'SCHEDULED';
}

/**
 * Transforms scoring data into CustomScoringQuestion props
 *
 * @param data - Scoring question data
 * @returns CustomScoringQuestion component props
 */
export function customScoringAdapter(data: ScoringQuestionData): CustomScoringQuestionProps {
  return {
    questionText: data.questionText,
    questionSubtext: data.questionSubtext,
    questionNumber: data.questionNumber,
    options: data.options.map(opt => ({
      option_id: opt.option_id,
      option_text_en: opt.option_text_en,
      option_text_fr: opt.option_text_fr,
      option_image_en: opt.option_image_en,
      option_image_fr: opt.option_image_fr,
      third_image_en: opt.third_image_en,
      third_image_fr: opt.third_image_fr,
      is_correct: opt.is_correct,
    })),
    points: data.totalPoints,
    status: data.status,
  };
}
